<style lang="scss" scoped>
.footer {
	width: 100%;
	height: 210px;
	text-align: center;
	color: #8d7464;
	font-size: 20px;
	line-height: 32px;
}
.footer-logo {
	margin-top: 25px;
	margin-bottom: 10px;
}
</style>

<template>
<div class="footer">
	<img class="footer-logo" src="../assets/pc/footer-logo.png" alt="">
	<div>
		<span style="margin-right: 10px;">家长监护</span>
		<span>适龄提示：本游戏适合18岁（含）以上玩家娱乐</span>
	</div>
	<div>
		<span>互联网ICP备案：<a @click="goPage">沪ICP备13003575-1号</a> | 上海掌梦网络科技有限公司</span>
	</div>
	<div>
		<span>沪公网安备 31011502017186号 | 上海掌梦网络科技有限公司</span>
	</div>

	<div>
		<span style="margin-right: 10px;">地址：上海市浦东新区乳山路233号德必WE402</span>
		<span>客服电话：021-58385528</span>
	</div>
</div>
</template>

<script>
export default {
	name: 'bottom-footer',
	methods: {
		goPage() {
			window.open('https://beian.miit.gov.cn/', '_blank')
		}
	}
}
</script>
